var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brain"},[_c('div',{staticClass:"page-wrapper chiller-theme toggled"},[_c('Sidenav'),_c('Headernav'),_c('div',{staticClass:"brain-children"},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }